import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/growth_analytics_event.py
export const GROWTH_ANALYTICS_ACTIONS = {
  OPENED_SHARE_LINK_CREATION_MODAL: {
    module: ANALYTICS_MODULE.GROWTH,
    action: 'opened_share_link_creation_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
  CLOSED_SHARE_LINK_METADATA_MODAL: {
    module: ANALYTICS_MODULE.GROWTH,
    action: 'closed_share_link_metadata_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
